import React from 'react'
import PropTypes from 'prop-types'
import './style.css'
import ButtonWithChevron from "../../_minha-central/ButtonWithChevron"

const NRTSaleActionBar = (props) => {
    return (
        <div className={'nrt-sale-action-bar'}>
            <ButtonWithChevron onClick={() => props.onClick()}
                               disabled={props.disabled}
                               buttonLabel={props.buttonLabel || 'AVANÇAR'}
                               loading={props.loading}
                               content={props.content} actionButton/>
        </div>
    )
}

NRTSaleActionBar.propTypes = {
    buttonLabel: PropTypes.string ,
    onClick: PropTypes.func.isRequired ,
    content: PropTypes.any  ,
    disabled: PropTypes.bool  ,
    loading: PropTypes.bool  ,

}

NRTSaleActionBar.defaultProps = {
    content: 'AVANÇAR',
    disabled: false ,
    loading: false ,
}

export default NRTSaleActionBar



// WEBPACK FOOTER //
// ./src/components/_sale/ActionButtonBar/index.js